<template>
  <div>
    <BaseListPage
        :name="name"
        :base-query="baseQuery"
        :store-path="storePath"
        :response-path="responsePath"
        :save-key="saveKey"
        :table-set-list="tableSetList"
        :table-data-list="sortedList"
        :min-column-width="'120px'"
        :async-render="true"
        :show-pagination="false"
        :is-max-get-count="false"
        :sum-table-list="sumTableRows"
        :sum-display-list="sumDisplayRows"
        title="販売売上レポート(デジタル)：期間分析"
        title-class="sales-header"
        icon="report">
      <span
          slot="headerAction"
          class="action_button">
        <span>
          <el-button
              id="displayTax"
              class="displayTax"
              size="small"
              @click="displayTax">
            {{ displayTax.textContent }}税込計算
          </el-button>
        </span>
        <el-dropdown
            v-show="showActionList">
          <el-button size="small">
            アクション
            <i class="el-icon-arrow-down el-icon--right" />
          </el-button>
          <el-dropdown-menu
              slot="dropdown"
              class="header-action-menu">
            <ToDownload
                ref="download"
                page-key="sales_digital_list"
                :conditions="conditions"
                :keyword="searchKeyword"
                :is-and-search="isAndSearch" />
          </el-dropdown-menu>
        </el-dropdown>
      </span>
    </BaseListPage>
  </div>
</template>

<script>
/* eslint-disable no-console */
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'

import * as define from '@/define'
import * as query from '@/queries/sales'
import x from '@/components/mixins/mixin'
import orderUtil from '@/components/mixins/orderUtil'

import BaseListPage from '@/components/pages/report/sales/SalesBaseListPage'
import ToDownload from '@/components/organisms/ToDownload'

export default {
  name: 'SalesDigitalList',
  components: {
    BaseListPage,
    ToDownload
  },
  mixins: [ x, orderUtil ],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      isDisplaySelectDialog: false,
      localIsParentLoaded: false,
      showActionList: false,
      isDisplayTax: false
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      listIndex: (state) => state.SalesDigital.listIndex,
      tableSetList: (state) => state.SalesDigital.tableSetList,
      searchKeyword: (state) => state.SalesDigital.searchKeyword || '',
      isAndSearch: (state) => state.SalesDigital.isAndSearch || false,
      conditions: (state) => state.SalesDigital.searchConditions || {},
      tdLists: (state) => state.SalesDigital.tdLists,
      sites: (state) => state.sites
    }),
    ...mapGetters({
      getSortedList: 'sortedList',
      getServiceSiteConfig: 'getServiceSiteConfig',
      searchConditions: 'searchConditions'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    name () {
      return 'SalesDigitalList'
    },
    storePath () {
      return 'SalesDigital'
    },
    saveKey () {
      return 'salesDigitalCondition'
    },
    responsePath () {
      return 'data.salesLists.edges'
    },
    returnPath () {
      return '/report/salesDigital'
    },
    baseQuery () {
      return 'query { ' + query.GRAPH_QL_QUERY_SALES_DIGITAL +
       query.GRAPH_QL_QUERY_SALES_LIST +
       '}}'
    },
    sortedList () {
      return this.getSortedList(this.storePath, this.sortCondition(this.name))
    },
    _tableSetList () {
      const taxMode = (this.isDisplayTax ? 'Gross' : 'Net')
      const taxName = (this.isDisplayTax ? '税込' : '税抜')
      const returnValue = [
        {
          itemKey: 'groupUnitMonth', isAvailable: true, isActive: false,
          type: 'String', label: '月', path: 'node.Month', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.GROUPBY_MONTH
        },
        {
          itemKey: 'groupUnitDay', isAvailable: true, isActive: false,
          type: 'String', label: '日', path: 'node.Day', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.GROUPBY_DAY
        },
        {
          itemKey: 'groupUnitHour', isAvailable: true, isActive: false,
          type: 'String', label: '時', path: 'node.Hour', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.GROUPBY_HOUR
        },
        {
          itemKey: 'groupUnitPaymentMethod', isAvailable: true, isActive: false,
          type: 'String', label: '支払方法', path: 'node.PaymentMethod', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.GROUPBY_PAYMENTMETHOD
        },
        {
          itemKey: 'groupUnitSite', isAvailable: true, isActive: false,
          type: 'String', label: 'サイト', path: 'node.Site', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.GROUPBY_SITE
        },
        {
          itemKey: 'cnt_sales', disabled: false,
          type: 'String', label: '売上件数',
          path: 'node.cnt_sumSales',
          sortBy: (row) => { return Number(row.node.cnt_sumSales) },
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.CNT_SALES
        },
        {
          itemKey: 'return_cnt', disabled: false,
          type: 'String', label: '返品件数',
          path: 'node.cnt_sumReturn',
          sortBy: (row) => { return Number(row.node.cnt_sumReturn) },
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.CNT_RETURNS
        },
        {
          itemKey: 'sales_product', disabled: false,
          type: 'Number', label: '売上(' + taxName + ')\r\n商品',
          path: 'node.sales' + taxMode + '_product',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALES_PRODUCT
        },
        {
          itemKey: 'sales_shipping', disabled: false,
          type: 'Number', label: '\r\n送料',
          path: 'node.sales' + taxMode + '_shipping',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALES_SHIPPING
        },
        {
          itemKey: 'sales_settlementTax', disabled: false,
          type: 'Number', label: '\r\n決済手数料',
          path: 'node.sales' + taxMode + '_settlementTax',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALES_SETTLEMENTTAX
        },
        {
          itemKey: 'sales_etc', disabled: false,
          type: 'Number', label: '\r\nその他',
          path: 'node.sales' + taxMode + '_etc',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALES_ETC
        },
        {
          itemKey: 'sales_point', disabled: false,
          type: 'Number', label: '\r\nポイント',
          path: 'node.sales' + taxMode + '_point',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALES_POINT
        },
        {
          itemKey: 'sales_commission', disabled: false,
          type: 'Number', label: '\r\n手数料',
          path: 'node.sales' + taxMode + '_commission',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALES_COMMISSION
        },
        {
          itemKey: 'sales_sum', disabled: false,
          type: 'Number', label: '\r\n合計',
          path: 'node.sales' + taxMode + '_sum',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALES_SUM
        },
        {
          itemKey: 'salesTax_product', disabled: false,
          type: 'Number', label: '消費税\r\n商品',
          path: 'node.salesTax_product',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALESTAX_PRODUCT
        },
        {
          itemKey: 'salesTax_shipping', disabled: false,
          type: 'Number', label: '\r\n送料',
          path: 'node.salesTax_shipping',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALESTAX_SHIPPING
        },
        {
          itemKey: 'salesTax_settlementTax', disabled: false,
          type: 'Number', label: '\r\n決済手数料',
          path: 'node.salesTax_settlementTax',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALESTAX_SETTLEMENTTAX
        },
        {
          itemKey: 'salesTax_etc', disabled: false,
          type: 'Number', label: '\r\nその他',
          path: 'node.salesTax_etc',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALESTAX_ETC
        },
        {
          itemKey: 'salesTax_point', disabled: false,
          type: 'Number', label: '\r\nポイント',
          path: 'node.salesTax_point',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALESTAX_POINT
        },
        {
          itemKey: 'salesTax_commission', disabled: false,
          type: 'Number', label: '\r\n手数料',
          path: 'node.salesTax_commission',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALESTAX_COMMISSION
        },
        {
          itemKey: 'salesTax_sum', disabled: false,
          type: 'Number', label: '\r\n合計',
          path: 'node.salesTax_sum',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALESTAX_SUM
        },
        {
          itemKey: 'return_product', disabled: false,
          type: 'Number', label: '返品(' + taxName + ')\r\n商品',
          path: 'node.return' + taxMode + '_product',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURN_PRODUCT
        },
        {
          itemKey: 'return_shipping', disabled: false,
          type: 'Number', label: '\r\n送料',
          path: 'node.return' + taxMode + '_shipping',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURN_SHIPPING
        },
        {
          itemKey: 'return_settlementTax', disabled: false,
          type: 'Number', label: '\r\n決済手数料',
          path: 'node.return' + taxMode + '_settlementTax',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURN_SETTLEMENTTAX
        },
        {
          itemKey: 'return_etc', disabled: false,
          type: 'Number', label: '\r\nその他',
          path: 'node.return' + taxMode + '_etc',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURN_ETC
        },
        {
          itemKey: 'return_point', disabled: false,
          type: 'Number', label: '\r\nポイント',
          path: 'node.return' + taxMode + '_point',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURN_POINT
        },
        {
          itemKey: 'return_commission', disabled: false,
          type: 'Number', label: '\r\n手数料',
          path: 'node.return' + taxMode + '_commission',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURN_COMMISSION
        },
        {
          itemKey: 'return_sum', disabled: false,
          type: 'Number', label: '\r\n合計',
          path: 'node.return' + taxMode + '_sum',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURN_SUM
        },
        {
          itemKey: 'returnTax_product', disabled: false,
          type: 'Number', label: '返品消費税\r\n商品',
          path: 'node.returnTax_product',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURNTAX_PRODUCT
        },
        {
          itemKey: 'returnTax_shipping', disabled: false,
          type: 'Number', label: '\r\n送料',
          path: 'node.returnTax_shipping',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURNTAX_SHIPPING
        },
        {
          itemKey: 'returnTax_settlementTax', disabled: false,
          type: 'Number', label: '\r\n決済手数料',
          path: 'node.returnTax_settlementTax',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURNTAX_SETTLEMENTTAX
        },
        {
          itemKey: 'returnTax_etc', disabled: false,
          type: 'Number', label: '\r\nその他',
          path: 'node.returnTax_etc',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURNTAX_ETC
        },
        {
          itemKey: 'returnTax_point', disabled: false,
          type: 'Number', label: '\r\nポイント',
          path: 'node.returnTax_point',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURNTAX_POINT
        },
        {
          itemKey: 'returnTax_commission', disabled: false,
          type: 'Number', label: '\r\n手数料',
          path: 'node.returnTax_commission',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURNTAX_COMMISSION
        },
        {
          itemKey: 'returnTax_sum', disabled: false,
          type: 'Number', label: '\r\n合計',
          path: 'node.returnTax_sum',
          sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURNTAX_SUM
        }
      ]

      return returnValue.sort((a, b) => a.displayOrder < b.displayOrder ? -1 : 1)
    },
    sumTableRows () {
      return this.sumDataList(this.sortedList)
    },
    sumDisplayRows () {
      const taxMode = (this.isDisplayTax ? 'Gross' : 'Net')
      const taxName = (this.isDisplayTax ? '税込' : '税抜')
      const sumLabels = [
        {
          itemKey: 'groupUnitMonth', isAvailable: true, isActive: false, width: null,
          type: 'String', label: '', path: 'Month',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.GROUPBY_MONTH
        },
        {
          itemKey: 'groupUnitDay', isAvailable: true, isActive: false, width: null,
          type: 'String', label: '', path: 'Day',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.GROUPBY_DAY
        },
        {
          itemKey: 'groupUnitHour', isAvailable: true, isActive: false, width: null,
          type: 'String', label: '', path: 'Hour',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.GROUPBY_HOUR
        },
        {
          itemKey: 'groupUnitPaymentMethod', isAvailable: true, isActive: false, width: null,
          type: 'String', label: '', path: 'PaymentMethod',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.GROUPBY_PAYMENTMETHOD
        },
        {
          itemKey: 'groupUnitSite', isAvailable: true, isActive: false, width: null,
          type: 'String', label: '', path: 'Site',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.GROUPBY_SITE
        },
        {
          itemKey: 'cnt_sales', isAvailable: true, isActive: true, width: null,
          type: 'String', label: '売上件数', path: 'cnt_sumSales',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.CNT_SALES
        },
        {
          itemKey: 'return_cnt', isAvailable: true, isActive: true, width: null,
          type: 'String', label: '返品件数', path: 'cnt_sumReturn',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.CNT_RETURNS
        },
        {
          itemKey: 'sales_product', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '売上(' + taxName + ')\r\n商品', path: 'sales' + taxMode + '_product',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALES_PRODUCT
        },
        {
          itemKey: 'sales_shipping', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\n送料', path: 'sales' + taxMode + '_shipping',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALES_SHIPPING
        },
        {
          itemKey: 'sales_settlementTax', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\n決済手数料', path: 'sales' + taxMode + '_settlementTax',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALES_SETTLEMENTTAX
        },
        {
          itemKey: 'sales_etc', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\nその他', path: 'sales' + taxMode + '_etc',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALES_ETC
        },
        {
          itemKey: 'sales_point', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\nポイント', path: 'sales' + taxMode + '_point',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALES_POINT
        },
        {
          itemKey: 'sales_commission', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\n手数料', path: 'sales' + taxMode + '_commission',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALES_COMMISSION
        },
        {
          itemKey: 'sales_sum', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\n合計', path: 'sales' + taxMode + '_sum',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALES_SUM
        },
        {
          itemKey: 'salesTax_product', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '消費税\r\n商品', path: 'salesTax_product',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALESTAX_PRODUCT
        },
        {
          itemKey: 'salesTax_shipping', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\n送料', path: 'salesTax_shipping',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALESTAX_SHIPPING
        },
        {
          itemKey: 'salesTax_settlementTax', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\n決済手数料', path: 'salesTax_settlementTax',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALESTAX_SETTLEMENTTAX
        },
        {
          itemKey: 'salesTax_etc', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\nその他', path: 'salesTax_etc',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALESTAX_ETC
        },
        {
          itemKey: 'salesTax_point', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\nポイント', path: 'salesTax_point',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALESTAX_POINT
        },
        {
          itemKey: 'salesTax_commission', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\n手数料', path: 'salesTax_commission',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALESTAX_COMMISSION
        },
        {
          itemKey: 'salesTax_sum', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\n合計', path: 'salesTax_sum',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.SALESTAX_SUM
        },
        {
          itemKey: 'return_product', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '返品(' + taxName + ')\r\n商品', path: 'return' + taxMode + '_product',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURN_PRODUCT
        },
        {
          itemKey: 'return_shipping', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\n送料', path: 'return' + taxMode + '_shipping',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURN_SHIPPING
        },
        {
          itemKey: 'return_settlementTax', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\n決済手数料', path: 'return' + taxMode + '_settlementTax',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURN_SETTLEMENTTAX
        },
        {
          itemKey: 'return_etc', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\nその他', path: 'return' + taxMode + '_etc',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURN_ETC
        },
        {
          itemKey: 'return_point', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\nポイント', path: 'return' + taxMode + '_point',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURN_POINT
        },
        {
          itemKey: 'return_commission', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\n手数料', path: 'return' + taxMode + '_commission',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURN_COMMISSION
        },
        {
          itemKey: 'return_sum', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\n合計', path: 'return' + taxMode + '_sum',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURN_SUM
        },
        {
          itemKey: 'returnTax_product', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '返品消費税\r\n商品', path: 'returnTax_product',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURNTAX_PRODUCT
        },
        {
          itemKey: 'returnTax_shipping', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\n送料', path: 'returnTax_shipping',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURNTAX_SHIPPING
        },
        {
          itemKey: 'returnTax_settlementTax', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\n決済手数料', path: 'returnTax_settlementTax',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURNTAX_SETTLEMENTTAX
        },
        {
          itemKey: 'returnTax_etc', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\nその他', path: 'returnTax_etc',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURNTAX_ETC
        },
        {
          itemKey: 'returnTax_point', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\nポイント', path: 'returnTax_point',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURNTAX_POINT
        },
        {
          itemKey: 'returnTax_commission', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\n手数料', path: 'returnTax_commission',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURNTAX_COMMISSION
        },
        {
          itemKey: 'returnTax_sum', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '\r\n合計', path: 'returnTax_sum',
          funcId: define.PermissionKeys.Report.Sales.Sales_list.RETURNTAX_SUM
        }
      ]
      return sumLabels
    }
  },
  async created () {
    this.$loadingService.show()
    try {
      // ダウンロードが可能のとき、アクションを表示
      const tempThisComponent = this
      setTimeout(() => {
        tempThisComponent.showActionList = this.$isFunctionShown(_.get(tempThisComponent.$refs, 'download.toDownload.funcId', ''))
      }, 1)

      this.$store.dispatch({
        type: 'set',
        states: {
          'SalesDigital/tableSetList': this._tableSetList
        }
      })
    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    } finally {
      this.$loadingService.close()
    }
  },
  beforeUpdate () {
    const labelMonth = this.tableSetList.filter(row => row.itemKey === 'groupUnitMonth')
    const labelDay = this.tableSetList.filter(row => row.itemKey === 'groupUnitDay')
    const labelHour = this.tableSetList.filter(row => row.itemKey === 'groupUnitHour')
    const labelPaymentMethod = this.tableSetList.filter(row => row.itemKey === 'groupUnitPaymentMethod')
    const labelSite = this.tableSetList.filter(row => row.itemKey === 'groupUnitSite')

    // グループ単位（月、日、支払方法、サイト）列の表示切替
    // 検索条件の指定により、画面上の検索条件を修正後、税込計算ボタン押下で更新され、項目が表示される。
    // ただし、GraphQL側で取得していないため、項目値がブランクになる。
    labelMonth[0].isAvailable = this.conditions['groupUnit'].value.includes('0')
    labelMonth[0].isActive = this.conditions['groupUnit'].value.includes('0')
    labelDay[0].isAvailable = this.conditions['groupUnit'].value.includes('1')
    labelDay[0].isActive = this.conditions['groupUnit'].value.includes('1')
    labelHour[0].isAvailable = this.conditions['groupUnit'].value.includes('2')
    labelHour[0].isActive = this.conditions['groupUnit'].value.includes('2')
    labelPaymentMethod[0].isAvailable = this.conditions['groupUnit'].value.includes('3')
    labelPaymentMethod[0].isActive = this.conditions['groupUnit'].value.includes('3')
    labelSite[0].isAvailable = this.conditions['groupUnit'].value.includes('4')
    labelSite[0].isActive = this.conditions['groupUnit'].value.includes('4')

    // 合計行のグループ単位列の表示切替
    const sumLabelMonth = this.sumDisplayRows.filter(row => row.itemKey === 'groupUnitMonth')
    const sumLabelDay = this.sumDisplayRows.filter(row => row.itemKey === 'groupUnitDay')
    const sumLabelHour = this.sumDisplayRows.filter(row => row.itemKey === 'groupUnitHour')
    const sumLabelPaymentMethod = this.sumDisplayRows.filter(row => row.itemKey === 'groupUnitPaymentMethod')
    const sumLabelSite = this.sumDisplayRows.filter(row => row.itemKey === 'groupUnitSite')

    sumLabelMonth[0].isAvailable = this.conditions['groupUnit'].value.includes('0')
    sumLabelMonth[0].isActive = this.conditions['groupUnit'].value.includes('0')
    sumLabelDay[0].isAvailable = this.conditions['groupUnit'].value.includes('1')
    sumLabelDay[0].isActive = this.conditions['groupUnit'].value.includes('1')
    sumLabelHour[0].isAvailable = this.conditions['groupUnit'].value.includes('2')
    sumLabelHour[0].isActive = this.conditions['groupUnit'].value.includes('2')
    sumLabelPaymentMethod[0].isAvailable = this.conditions['groupUnit'].value.includes('3')
    sumLabelPaymentMethod[0].isActive = this.conditions['groupUnit'].value.includes('3')
    sumLabelSite[0].isAvailable = this.conditions['groupUnit'].value.includes('4')
    sumLabelSite[0].isActive = this.conditions['groupUnit'].value.includes('4')
  },
  methods: {
    displayTax: function () {
      const btn = document.getElementById('displayTax')
      if (this.isDisplayTax) {
        this.isDisplayTax = false
        btn.textContent = '税込計算'
      } else {
        this.isDisplayTax = true
        btn.textContent = '税抜計算'
      }

      const taxMode = (this.isDisplayTax ? 'Gross' : 'Net')
      const taxName = (this.isDisplayTax ? '税込' : '税抜')
      const targetPriceList = [ 'sales', 'return' ]
      const targetParamList = [ 'product', 'shipping', 'settlementTax', 'etc', 'point', 'commission', 'sum' ]

      // 一覧リロード対象のパラメータを設定する
      for (const tableSetItem of this.tableSetList) {
        for (const targetPriceItem of targetPriceList) {
          for (const targetParamItem of targetParamList) {
            if (tableSetItem.itemKey === targetPriceItem + '_' + targetParamItem) {
              tableSetItem.path = 'node.' + targetPriceItem + taxMode + '_' + targetParamItem
            }
            if (tableSetItem.itemKey === 'sales_product') {
              tableSetItem.label = '売上(' + taxName + ')\r\n商品'
            } else if (tableSetItem.itemKey === 'return_product') {
              tableSetItem.label = '返品(' + taxName + ')\r\n商品'
            }
          }
        }
      }

      // 合計行リロード対象のパラメータを設定する
      for (const sumDisplayItem of this.sumDisplayRows) {
        for (const targetPriceItem of targetPriceList) {
          for (const targetParamItem of targetParamList) {
            if (sumDisplayItem.itemKey === targetPriceItem + '_' + targetParamItem) {
              sumDisplayItem.path = targetPriceItem + taxMode + '_' + targetParamItem
            }
            if (sumDisplayItem.itemKey === 'sales_product') {
              sumDisplayItem.label = '売上(' + taxName + ')\r\n商品'
            } else if (sumDisplayItem.itemKey === 'return_product') {
              sumDisplayItem.label = '返品(' + taxName + ')\r\n商品'
            }
          }
        }
      }
    },
    getFuncId: function (rows, itemKey) {
      return rows.filter(row => row.itemKey === itemKey)[0].funcId
    },
    // 合計算出
    sumDataList: function (sortedItems) {
      const data = new Array(44).fill(0)

      // 検索条件に設定されたグループ単位ラベル用のデータ配列
      // グループ単位として表示する最後のデータ項目に'合計'を設定する
      let displayGroupby = ['', '', '', '', '']
      displayGroupby[4] = this.conditions['groupUnit'].value.includes('4') ? '合計' : ''
      if (this.conditions['groupUnit'].value.includes('4') && (this.$isFunctionShown(this.getFuncId(this.sumDisplayRows, 'groupUnitSite')))) {
        displayGroupby[4] = '合計'
      } else if (this.conditions['groupUnit'].value.includes('3') && (this.$isFunctionShown(this.getFuncId(this.sumDisplayRows, 'groupUnitPaymentMethod')))) {
        displayGroupby[3] = '合計'
      } else if (this.conditions['groupUnit'].value.includes('2') && (this.$isFunctionShown(this.getFuncId(this.sumDisplayRows, 'groupUnitHour')))) {
        displayGroupby[2] = '合計'
      } else if (this.conditions['groupUnit'].value.includes('1') && (this.$isFunctionShown(this.getFuncId(this.sumDisplayRows, 'groupUnitDay')))) {
        displayGroupby[1] = '合計'
      } else if (this.conditions['groupUnit'].value.includes('0') && (this.$isFunctionShown(this.getFuncId(this.sumDisplayRows, 'groupUnitMonth')))) {
        displayGroupby[0] = '合計'
      }

      // 一覧データをループし、合計金額を算出
      for (const row of sortedItems) {
        data[0] += Number(row.node.cnt_sumSales)
        data[1] += Number(row.node.cnt_sumReturn)
        data[2] += Number(row.node.salesGross_product)
        data[3] += Number(row.node.salesNet_product)
        data[4] += Number(row.node.salesGross_shipping)
        data[5] += Number(row.node.salesNet_shipping)
        data[6] += Number(row.node.salesGross_settlementTax)
        data[7] += Number(row.node.salesNet_settlementTax)
        data[8] += Number(row.node.salesGross_etc)
        data[9] += Number(row.node.salesNet_etc)
        data[10] += Number(row.node.salesGross_point)
        data[11] += Number(row.node.salesNet_point)
        data[12] += Number(row.node.salesGross_commission)
        data[13] += Number(row.node.salesNet_commission)
        data[14] += Number(row.node.salesGross_sum)
        data[15] += Number(row.node.salesNet_sum)
        data[16] += Number(row.node.salesTax_product)
        data[17] += Number(row.node.salesTax_shipping)
        data[18] += Number(row.node.salesTax_settlementTax)
        data[19] += Number(row.node.salesTax_etc)
        data[20] += Number(row.node.salesTax_point)
        data[21] += Number(row.node.salesTax_commission)
        data[22] += Number(row.node.salesTax_sum)
        data[23] += Number(row.node.returnGross_product)
        data[24] += Number(row.node.returnNet_product)
        data[25] += Number(row.node.returnGross_shipping)
        data[26] += Number(row.node.returnNet_shipping)
        data[27] += Number(row.node.returnGross_settlementTax)
        data[28] += Number(row.node.returnNet_settlementTax)
        data[29] += Number(row.node.returnGross_etc)
        data[30] += Number(row.node.returnNet_etc)
        data[31] += Number(row.node.returnGross_point)
        data[32] += Number(row.node.returnNet_point)
        data[33] += Number(row.node.returnGross_commission)
        data[34] += Number(row.node.returnNet_commission)
        data[35] += Number(row.node.returnGross_sum)
        data[36] += Number(row.node.returnNet_sum)
        data[37] += Number(row.node.returnTax_product)
        data[38] += Number(row.node.returnTax_shipping)
        data[39] += Number(row.node.returnTax_settlementTax)
        data[40] += Number(row.node.returnTax_etc)
        data[41] += Number(row.node.returnTax_point)
        data[42] += Number(row.node.returnTax_commission)
        data[43] += Number(row.node.returnTax_sum)
      }

      // 返却用配列
      let rtnSumData = []
      // 合計金額を算出用配列に格納
      let sumData = []
      sumData['Month'] = displayGroupby[0]
      sumData['Day'] = displayGroupby[1]
      sumData['Hour'] = displayGroupby[2]
      sumData['PaymentMethod'] = displayGroupby[3]
      sumData['Site'] = displayGroupby[4]
      sumData['cnt_sumSales'] = data[0].toLocaleString()
      sumData['cnt_sumReturn'] = data[1].toLocaleString()
      sumData['salesGross_product'] = data[2].toLocaleString()
      sumData['salesNet_product'] = data[3].toLocaleString()
      sumData['salesGross_shipping'] = data[4].toLocaleString()
      sumData['salesNet_shipping'] = data[5].toLocaleString()
      sumData['salesGross_settlementTax'] = data[6].toLocaleString()
      sumData['salesNet_settlementTax'] = data[7].toLocaleString()
      sumData['salesGross_etc'] = data[8].toLocaleString()
      sumData['salesNet_etc'] = data[9].toLocaleString()
      sumData['salesGross_point'] = data[10].toLocaleString()
      sumData['salesNet_point'] = data[11].toLocaleString()
      sumData['salesGross_commission'] = data[12].toLocaleString()
      sumData['salesNet_commission'] = data[13].toLocaleString()
      sumData['salesGross_sum'] = data[14].toLocaleString()
      sumData['salesNet_sum'] = data[15].toLocaleString()
      sumData['salesTax_product'] = data[16].toLocaleString()
      sumData['salesTax_shipping'] = data[17].toLocaleString()
      sumData['salesTax_settlementTax'] = data[18].toLocaleString()
      sumData['salesTax_etc'] = data[19].toLocaleString()
      sumData['salesTax_point'] = data[20].toLocaleString()
      sumData['salesTax_commission'] = data[21].toLocaleString()
      sumData['salesTax_sum'] = data[22].toLocaleString()
      sumData['returnGross_product'] = data[23].toLocaleString()
      sumData['returnNet_product'] = data[24].toLocaleString()
      sumData['returnGross_shipping'] = data[25].toLocaleString()
      sumData['returnNet_shipping'] = data[26].toLocaleString()
      sumData['returnGross_settlementTax'] = data[27].toLocaleString()
      sumData['returnNet_settlementTax'] = data[28].toLocaleString()
      sumData['returnGross_etc'] = data[29].toLocaleString()
      sumData['returnNet_etc'] = data[30].toLocaleString()
      sumData['returnGross_point'] = data[31].toLocaleString()
      sumData['returnNet_point'] = data[32].toLocaleString()
      sumData['returnGross_commission'] = data[33].toLocaleString()
      sumData['returnNet_commission'] = data[34].toLocaleString()
      sumData['returnGross_sum'] = data[35].toLocaleString()
      sumData['returnNet_sum'] = data[36].toLocaleString()
      sumData['returnTax_product'] = data[37].toLocaleString()
      sumData['returnTax_shipping'] = data[38].toLocaleString()
      sumData['returnTax_settlementTax'] = data[39].toLocaleString()
      sumData['returnTax_etc'] = data[40].toLocaleString()
      sumData['returnTax_point'] = data[41].toLocaleString()
      sumData['returnTax_commission'] = data[42].toLocaleString()
      sumData['returnTax_sum'] = data[43].toLocaleString()

      this.$set(rtnSumData, 0, sumData)
      return rtnSumData
    }
  }
}
</script>

<style scoped>
  .prefixTableRow .el-button {
    text-align: center;
    margin-bottom: 10px;
  }
  .prefixTableRow .el-button ::v-deep span {
    margin: 0px;
  }

  .base-list-page ::v-deep .description .cell .inner-cell div {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
  }
</style>
